import { useState, useEffect, useContext } from "react";
import { uploadImage } from "../../../../api/utils";
import Input from "../../../../components/elements/form/Input";
import ButtonAction from "../../../elements/buttons/ButtonAction";
import H3 from "../../../elements/titles/H3";
import InputFile from "../../../elements/form/InputFile";
import { createCategory } from "../../../../api/categories/categoriesApi";
import currentAdminContext from "../../../../dataManager/context/currentAdminContext";
import { getDocumentRef } from "../../../../api/utils";
import { toast } from "react-toastify";
import { checkFiels } from "../../../../functions/functions";

const AddCategory = () => {
  // context variables
  const { currentAdmin } = useContext(currentAdminContext);

  //form state
  const [name, setName] = useState("");
  const [starsNumber, setStarsNumber] = useState(0);
  const [image, setImage] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  //state variables using t upload image on firebase
  const [imageUrl, setImageUrl] = useState("");
  const [progressLoadingImage, setProgressLoadingImage] = useState(0);
  const [isLoadingImage, setIsLoadingImage] = useState(false);

  useEffect(() => {
    if (imageUrl) {
      addCategory();
    }
  }, [imageUrl]);

  const addCategory = async () => {
    //get the ref to the creator of the
    const creatorOfCategoryRef = getDocumentRef("admins", currentAdmin.getId);

    const { data, error } = await createCategory({
      name,
      image: imageUrl,
      starsNumber,
      creatorOfCategory: creatorOfCategoryRef,
      creationDate: Date.now(),
    });

    if (error) {
      setError(error);
      setLoading(false);
    }

    setName("");
    setImage(null);
    setStarsNumber(0);
    setImageUrl("");
    setProgressLoadingImage(0);
    setLoading(false);
    toast.success("La catégorie a été créée avec succès", { theme: "colored" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!checkFiels({ name, starsNumber, image })) {
      return setError(
        "Veuillez remplir tous les champs pour créer cette catégorie de produits"
      );
    }

    setLoading(true);

    //uplooad image to firebase
    uploadImage(
      "categories",
      image,
      setImageUrl,
      setProgressLoadingImage,
      setIsLoadingImage
    );
  };

  return (
    <>
      <form className="mt-8 max-w-md md:mt-12" onSubmit={handleSubmit}>
        <H3>Ajouter une nouvelle catégorie de produit dans votre boutique</H3>

        <div className="mt-4 flex flex-col space-y-4">
          <InputFile
            value=""
            onChange={(e) => {
              setError("");
              setImage(e.target.files[0]);
            }}
            labelName="Image de la catégorie"
            name="image-category"
          />
          <Input
            labelName="Nom cathégorie"
            type="text"
            name="name-category"
            placeholder="desktop"
            value={name}
            onChange={(e) => {
              setError("");
              setName(e.target.value);
            }}
          />
          <Input
            labelName="Nombre d'étoiles"
            type="number"
            name="stars-category"
            placeholder="3"
            value={starsNumber}
            onChange={(e) => {
              setError("");
              setStarsNumber(e.target.value);
            }}
            min="0"
            max="5"
          />
        </div>
        <ButtonAction size="small" classe="mt-2" loading={loading}>
          Ajouter la catégorie
        </ButtonAction>
      </form>
      <span className="font-nunito text-sm text-[#fc3838]">
        {error && error}
      </span>
    </>
  );
};

export default AddCategory;
